import { ChangeEvent, FC, useState } from 'react';
import { ActionMeta, MultiValue, SingleValue } from 'react-select';
import Input from '../../../../../common/input/input';
import Select, { SingleSelect } from '../../../../../common/select/select';
import { LATINA_COUNTRY_CODE } from '../../../../../constants/latina-country';
import translation from '../../../../../languages';
import { CASH_FORM_NAMES, CASH_SELECT_STYLES } from '../constants/kushki';
import { KushkiCashType } from '../types/kushki-types';
import { updateDocumentTypeData } from '../utils/kushki';

type KushkiCashProps = TranslationProps & {
    cashData: KushkiCashType;
    formErrors: string[];
    onCashDataChange: (name: string, value: string) => void;
    region: LATINA_COUNTRY_CODE;
};

const KushkiCash: FC<KushkiCashProps> = ({ cashData, onCashDataChange, region, t, formErrors }) => {
    const [documentType, setDocumentType] = useState<SingleValue<SingleSelect>>(updateDocumentTypeData(region)[0]);

    const handleSelectChange = (
        newValue: SingleValue<SingleSelect> | MultiValue<SingleSelect>,
        actionMeta: ActionMeta<SingleSelect>
    ) => {
        // @ts-ignore
        setDocumentType(newValue);

        if (newValue) {
            // @ts-ignore
            onCashDataChange(actionMeta.name!, newValue.value);
        }
    };

    const handleUpdateForm = (e: ChangeEvent<HTMLInputElement>) => {
        onCashDataChange(e.target.name, e.target.value);
    };

    return (
        <div>
            <div className='payment-flex mb-4'>
                <div className='mr-3'>
                    <span>{t('payment.kushki.cash.firstName')}</span>
                    <Input
                        className='payment-input-grope'
                        error={formErrors.includes(CASH_FORM_NAMES.FIRST_NAME)}
                        name={CASH_FORM_NAMES.FIRST_NAME}
                        type='text'
                        value={cashData.firstName}
                        onChange={handleUpdateForm}
                    />
                </div>
                <div>
                    <span>{t('payment.kushki.cash.lastName')}</span>
                    <Input
                        className='payment-input-grope'
                        error={formErrors.includes(CASH_FORM_NAMES.LAST_NAME)}
                        name={CASH_FORM_NAMES.LAST_NAME}
                        type='text'
                        value={cashData.lastName}
                        onChange={handleUpdateForm}
                    />
                </div>
            </div>

            <div className='payment-flex mb-4'>
                <div className='mr-3'>
                    <span>{t('payment.kushki.documentType')}</span>
                    <Select
                        customStyle={CASH_SELECT_STYLES}
                        name={CASH_FORM_NAMES.DOCUMENT_TYPE}
                        options={updateDocumentTypeData(region)}
                        placeholder='documentType'
                        value={documentType}
                        onChange={handleSelectChange}
                    />
                </div>
                <div>
                    <span>{t('payment.kushki.documentNumber')}</span>
                    <Input
                        className='payment-input-doc-number-cash'
                        error={formErrors.includes(CASH_FORM_NAMES.DOCUMENT_NUMBER)}
                        maxLength={20}
                        name={CASH_FORM_NAMES.DOCUMENT_NUMBER}
                        type='text'
                        value={cashData.documentNumber}
                        onChange={handleUpdateForm}
                    />
                </div>
            </div>
        </div>
    );
};
const translate = translation('payment');

export default translate(KushkiCash);
